import get from 'lodash/get';
import SelectFirstAnswerShown from './select_first_answer_shown';
import { getSearchContext, getSearchResultContexts, snowplowTypes } from 'scripts/lib/analytics/snowplow';

export default class HandleAnswerSearchResults {
  constructor(context) {
    this.context = context;
  }

  run({ search }) {
    let answerPanel = this.context.stores.answerPanel.getPending();
    const pendingSearch = get(answerPanel, 'searchResult');
    if (!pendingSearch || !pendingSearch.isLoading || pendingSearch.id !== search.id) {
      return;
    }

    answerPanel.setSearchResult(search);
    this.context.stores.answerPanel.resetPending();
    this.context.stores.answerPanel.set(answerPanel);
    this.context.executeAction(SelectFirstAnswerShown);

    const snowplowContexts = [getSearchContext(search), ...getSearchResultContexts(search.hits)];
    this.context.analytics.trackSnowplow(
      snowplowTypes.EVENT_ANSWER_SEARCHED,
      { sortType: search.query.sort, language: search.query.languages },
      snowplowContexts
    );
  }
}
